/* eslint-disable */

import './titleBox.module.scss';
import React from 'react';
import classNames from 'classnames';
type Props = {
  title: string;
  titleColor: 'white' | 'black';
  subTitle: string;
  disabled?: boolean;
  fontFamily?: 'europa' | 'yu-gothic';
};
export class TitleBox extends React.PureComponent<Props, any> {
  render() {
    const { title, subTitle, titleColor, fontFamily = 'europa' } = this.props;
    return (
      <div styleName={classNames('title-box', titleColor)}>
        <div styleName={classNames('title', fontFamily)}>{title}</div>
        <div styleName="sub-title">{subTitle}</div>
      </div>
    );
  }
}
